const state = {
    stMenu:  [
        {
          ruta: "/user/edit-profile",
          tag: "li",
          texto: "editar mi perfil",
          orden: 1,
          mostrar: true,
        },
        {
          ruta: "/user/dogs",
          tag: "li",
          texto: "mis perros",
          orden: 2,
          mostrar: true,
        },
        {
          ruta: "/user/inscriptions",
          tag: "li",
          texto: "inscribir perros",
          orden: 3,
          mostrar: true,
        },
        {
          ruta: "/user/payments",
          tag: "li",
          texto: "inscripciones pagos",
          orden: 4,
          mostrar: true,
        },
        {
          ruta: "/user/documents",
          tag: "li",
          texto: "gestor documentos",
          orden: 5,
          mostrar: false,
        },
        {
          ruta: "/user/races",
          tag: "li",
          texto: "reconocimiento razas",
          orden: 6,
          mostrar: false,
        },
        {
          ruta: "/user/dorsals",
          tag: "li",
          texto: "dorsales entradas",
          orden: 7,
          mostrar: false,
        },
        {
          ruta: "/user/catalogues",
          tag: "li",
          texto: "catalogos",
          orden: 8,
          mostrar: false,
        },
        {
          ruta: "/user/contact",
          tag: "li",
          texto: "contacto",
          orden: 9,
          mostrar: true,
        },
      ],
}

const getters = {
    getterStMenu(state) {
        return state.stMenu.filter(m => m.mostrar);
    }
}

export const menu = {
    namespaced: true,
    state,
    getters
}